<template>
  <el-card
    v-loading="loading"
    class="clear-card sessionDetails"
    shadow="hover"
    :body-style="{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
    }"
  >
    <div
      slot="header"
      class="header"
    >
      <span class="title defaultCursor">{{ $t('coach.leader.sessionDetail.title') }}</span>

      <span class="prevSessionBtn">
        <el-button
          icon="el-icon-arrow-left"
          circle
          :disabled="session <= 1"
          @click="session = session - 1"
        />
      </span>
      <span class="currentSession">{{ session ? session : '-' }}</span>
      <span class="nextSessionBtn">
        <el-button
          icon="el-icon-arrow-right"
          circle
          :disabled="sessionMaximum"
          @click="session = session + 1"
        />
      </span>

      <span class="currentSessionBtn">
        <el-button
          class="currentBtn"
          round
          @click="toggleCurrentSession"
        >
          {{ $t('coach.leader.sessionDetail.current') }}
        </el-button>
      </span>
    </div>
    <div
      v-if="sessionTasks"
      class="content"
    >
      <el-row>
        <el-col :span="responseCol">
          <div class="title">
            {{ $t('coach.leader.sessionDetail.myTasks') }}
          </div>
          <template v-if="formattedCoachTask && formattedCoachTask.length">
            <div
              v-for="(task, key) in formattedCoachTask"
              :key="key"
              class="task"
              @click="clickTask(task)"
            >
              <div
                class="status"
                :class="{completed: task.status === 'completed'}"
              ></div>
              <div class="name">
                {{ $t(`processTasks.${task.description}`) }}
              </div>
            </div>
          </template>
          <div
            v-else
            class="noData"
          >
            {{ $t('coach.leader.sessionDetail.noData') }}
          </div>
        </el-col>

        <el-col :span="responseCol">
          <div class="title">
            {{ $t('coach.leader.sessionDetail.leaderTasks') }}
          </div>
          <template v-if="formattedLeaderTask && formattedLeaderTask.length">
            <div
              v-for="(task, key) in formattedLeaderTask"
              :key="key"
              class="task"
            >
              <div
                class="status"
                :class="{completed: task.status === 'completed'}"
              ></div>
              <div class="name">
                {{ $t(`processTasks.${task.description}`) }}
              </div>
            </div>
          </template>
          <div
            v-else
            class="noData"
          >
            {{ $t('coach.leader.sessionDetail.noData') }}
          </div>
        </el-col>
      </el-row>
    </div>
  </el-card>
</template>

<script>
import api from '@/api';
import TaskFilterBoth from './TaskFilterBoth';

export default {
  props: {
    leaderUuid: {
      type: String,
      default: '',
    },

    leader: {
      type: Object,
      default: null,
    },

    currentSession: {
      type: Number,
      default: 1,
    },

    meetings: {
      type: Object,
      default: null,
    },

    tasksData: {
      type: Object,
      default: null,
    },

    sessionData: {
      type: Number,
      default: null,
    },

    loadTasks: {
      type: Boolean,
      default: true,
    },

    engagement: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      localSession: 1,
      localSessionTasks: null,
      loading: false,
    };
  },

  computed: {
    sessionTasks() {
      if (this.tasksData) return this.tasksData;
      return this.localSessionTasks;
    },

    session: {
      get() {
        if (this.sessionData) return this.sessionData;
        return this.localSession;
      },
      set(value) {
        if (this.sessionData) {
          this.$emit('update:sessionData', value);
        } else {
          this.localSession = value;
        }
      },
    },

    sessionMaximum() {
      let flag = false;
      if (this.engagement) {
        flag = this.session === this.engagement.duration;
      } else if (this.leader && (this.leader.duration === this.currentSession)) {
        flag = this.session === this.currentSession - 1;
      } else {
        flag = this.session === this.currentSession;
      }
      return flag;
    },

    responseCol() {
      let col = 12;
      if (['mobile', 'tablet', 'laptop'].includes(this.$mq)) {
        col = 24;
      }
      return col;
    },

    sessionOneStatus() {
      let status = 'on_going';
      if (this.meetings && this.meetings.meeting_status) {
        const sessionOne = this.meetings.meeting_status.find((el) => el.session_id === 'session_1');
        if (sessionOne && sessionOne.status) {
          status = sessionOne.status;
        }
      }
      return status;
    },

    formattedLeaderTask() {
      let tasks = [];

      if (this.sessionTasks && this.sessionTasks.leader_tasks) {
        // const basic = this.sessionTasks.leader_tasks
        //   .filter((task) => task.description.startsWith('scheduleSession'));

        const filtered = this.sessionTasks.leader_tasks
          .filter((task) => TaskFilterBoth.sessions.leader[this.sessionTasks.session_id]
            .includes(task.description));

        tasks = [...filtered];
      }

      return tasks;
    },

    formattedCoachTask() {
      let tasks = [];

      // sessionTasks.coach_tasks
      if (this.sessionTasks && this.sessionTasks.coach_tasks) {
        if (this.sessionTasks.session_id === 'session_1') {
          if (this.sessionOneStatus === 'completed') {
            const filtered = this.sessionTasks.coach_tasks
              .filter((task) => TaskFilterBoth.sessions.coach.after_1
                .includes(task.description));
            tasks = [...filtered];
          } else {
            const filtered = this.sessionTasks.coach_tasks
              .filter((task) => TaskFilterBoth.sessions.coach.session_1
                .includes(task.description));
            tasks = [...filtered];
          }
        } else {
          tasks = [...this.sessionTasks.coach_tasks];
        }
      }

      return tasks;
    },
  },

  watch: {
    session: {
      // immediate: true,
      handler() {
        if (this.loadTasks) {
          this.getLeaderSessionTasks();
        }
      },
    },

    leaderUuid() {
      // force reload of getLeaderSessionTasks when changing leader
      this.session = this.currentSession;
    },
  },

  created() {
    if (!this.currentSession) {
      this.session = 0;
    } else if (this.leader && (this.leader.duration === this.currentSession)) {
      this.session = this.currentSession - 1;
    } else {
      this.session = this.currentSession;
    }
    if (this.loadTasks) {
      this.getLeaderSessionTasks();
    }
  },

  methods: {
    async getLeaderSessionTasks() {
      try {
        this.loading = true;
        if (this.session && this.session > 0) {
          const response = await api.getCoachLeaderProcess(this.leaderUuid, {
            session_id: `session_${this.session}`,
          });
          [this.localSessionTasks] = response.data;
        }
        this.loading = false;
      } catch (err) {
        console.log(err);
        if (err.msg) {
          this.$message.error(err.msg);
        }
        this.loading = false;
      }
    },

    async clickTask(task) {
      try {
        this.loading = true;
        const response = await api.saveCoachTask(this.leaderUuid, {
          coach_task_id: task.coach_task_id,
          status: task.status === 'completed' ? 'ongoing' : 'completed',
        });

        const index = this.sessionTasks.coach_tasks.findIndex(
          (el) => el.coach_task_id === task.coach_task_id,
        );
        this.$set(this.sessionTasks.coach_tasks[index], 'status', response.data.status);

        this.loading = false;
      } catch (err) {
        console.log(err);
        if (err.msg) {
          this.$message.error(err.msg);
        }
        this.loading = false;
      }
    },

    toggleCurrentSession() {
      if (this.engagement) {
        this.session = this.engagement.duration;
      } else if (this.leader && (this.leader.duration === this.currentSession)) {
        this.session = this.currentSession - 1;
      } else {
        this.session = this.currentSession;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.sessionDetails {
  .noData {
    color: #c4c4c4;
    padding: 10px 0;
  }

  .header {
    font-weight: bold;
    text-align: left;
    position: relative;
    display: flex;
    align-items: center;
    margin: -10px 0;

    .el-button {
      background-color: transparent;
      color: var(--themeFontColor);

      &.is-disabled {
        background-color: #ffffff21;
      }
    }

    .prevSessionBtn {
      margin: 0 3%;

      .el-button {
        padding: 10px;
      }
    }

    .nextSessionBtn {
      margin: 0 3%;

      .el-button {
        padding: 10px;
      }
    }

    .currentSession {
      vertical-align: middle;
    }

    .currentSessionBtn {
      width: 100%;
      text-align: right;

      .currentBtn {
        padding: 12px 16px;
      }
    }
  }

  .content {
    text-align: left;

    .title {
      font-weight: bold;
    }

    .task {
      display: flex;
      padding: 15px 5px 15px 0;
      align-items: center;

      .status {
        min-width: 12px;
        width: 12px;
        height: 12px;
        border-radius: 50%;
        margin-right: 10px;
        background: #c4c4c4;

        &.completed {
          background: #66d73f;
        }
      }

      .name {
        width: 100%;
        word-break: break-word;
      }

      &:not(.disabled):hover {
        background-color: rgba(255, 255, 255, 0.2);
        cursor: pointer;
      }

      &.disabled {
        color: #ffffff6b;

        &:hover {
          cursor: not-allowed;
        }
      }
    }
  }
}
</style>
